export const ContainsSecurityBoundary = (
    securityBoundaries: Services.Coam.Resource[] | undefined,
    securityBoundary: string | undefined,
): boolean => !!securityBoundaries?.find((s) => s.identifier === securityBoundary);
